import type { ReactNode } from "react";

interface QuestionShellProps {
  stepId: string;
  index: number;
  title: string;
  description?: string;
  helpText?: string;
  required?: boolean;
  children: ReactNode;
}

/** Large-type, single-question layout shared by every step renderer. */
export function QuestionShell({
  stepId,
  index,
  title,
  description,
  helpText,
  required,
  children,
}: QuestionShellProps) {
  const titleId = `q-${stepId}-title`;
  const descId = description ? `q-${stepId}-desc` : undefined;
  return (
    <section aria-labelledby={titleId} aria-describedby={descId} className="w-full">
      <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-brand-600">
        Question {index}
      </p>
      <h1
        id={titleId}
        className="text-2xl font-bold leading-tight text-ink sm:text-3xl md:text-4xl"
      >
        {title}
        {required ? <span className="ml-1 text-brand-500" aria-hidden="true">*</span> : null}
      </h1>
      {description ? (
        <p id={descId} className="mt-3 text-lg text-ink-soft">
          {description}
        </p>
      ) : null}

      <div className="mt-7">{children}</div>

      {helpText ? <p className="mt-4 text-sm text-ink-muted">{helpText}</p> : null}
    </section>
  );
}
